import { render, staticRenderFns } from "./saaspay.vue?vue&type=template&id=35a795b7&scoped=true"
import script from "./saaspay.vue?vue&type=script&lang=js"
export * from "./saaspay.vue?vue&type=script&lang=js"
import style0 from "./saaspay.vue?vue&type=style&index=0&id=35a795b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a795b7",
  null
  
)

export default component.exports